import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Contextual help button that appears below SystemMetrics.
 * Shows page-specific help text in a MC-styled modal.
 */

const helpContent = {
  '/': {
    title: 'Dashboard',
    text: `Das Dashboard zeigt eine Uebersicht aller Server mit Status, Spieleranzahl und wichtigen Statistiken.\n\nHier siehst du auf einen Blick, welche Server laufen und wie viele Spieler online sind.`,
  },
  '/servers': {
    title: 'Server-Verwaltung',
    text: `Hier werden alle Minecraft-Server aufgelistet. Du kannst neue Server erstellen, bestehende starten/stoppen und deren Konfiguration bearbeiten.\n\nKlicke auf einen Server fuer Details wie Konsole, Properties und Weltenverwaltung.`,
  },
  '/mods': {
    title: 'Mod-Verwaltung',
    text: `Suche und installiere Mods von Modrinth. Die Mod-Bibliothek speichert heruntergeladene Mods zentral.\n\nVon hier aus kannst du Mods auf einzelne Server installieren, aktivieren oder deaktivieren.`,
  },
  '/modpacks': {
    title: 'Modpack-Verwaltung',
    text: `Importiere und verwalte Modpacks. Lade .zip oder .mrpack Dateien hoch und erstelle damit neue Server.\n\nModpacks koennen auch exportiert werden, um sie mit anderen Spielern zu teilen.`,
  },
  '/players': {
    title: 'Spieler-Verwaltung',
    text: `Verwalte Online-Spieler, Whitelist, Bans und Operator-Rechte.\n\nWhitelist-Anfragen von neuen Spielern erscheinen hier automatisch und koennen genehmigt oder abgelehnt werden.\n\nDer Aktionsverlauf zeigt alle Aenderungen an der Spielerverwaltung.`,
  },
  '/backups': {
    title: 'Backup-Verwaltung',
    text: `Erstelle, lade herunter und stelle Backups fuer jeden Server wieder her.\n\nAutomatische Backups koennen pro Server aktiviert werden. Konfiguriere Intervall und Aufbewahrungsfristen im Zeitplan-Bereich.\n\nDie Ausduennung loescht aeltere Backups automatisch nach den konfigurierten Regeln:\n- Innerhalb der Stunden-Frist: Alle behalten\n- Innerhalb der Tage-Frist: 1 pro Tag\n- Innerhalb der Wochen-Frist: 1 pro Woche\n- Aelter: Wird geloescht`,
  },
  '/users': {
    title: 'Benutzerverwaltung',
    text: `Erstelle und verwalte Benutzerkonten fuer Spieler und Admins.\n\nPasswoerter koennen zurueckgesetzt werden. Das neue Passwort gilt sofort.\n\nDas Gast-Protokoll zeigt, welche Gaeste die Seite besucht haben.`,
  },
  '/rules': {
    title: 'Regeln bearbeiten',
    text: `Bearbeite den Titel und Inhalt der Server-Regeln.\n\nDer hier eingegebene Text wird Spielern auf ihrer "Regeln & Info"-Seite angezeigt.\n\nZeilenumbrueche werden uebernommen. Die Vorschau unten zeigt, wie der Text fuer Spieler aussieht.`,
  },
  '/feedback': {
    title: 'Feedback-Verwaltung',
    text: `Hier siehst du alle Feedback-Eintraege, die Gaeste, Spieler und Admins ueber den Feedback-Button gesendet haben.\n\nJeder Eintrag enthaelt die Nachricht, Seiteninfo und optional einen Screenshot.\n\nEintraege koennen geloescht werden, wenn sie bearbeitet wurden.`,
  },
};

function HelpButton() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Match current path to help content
  // For /servers/:id, match /servers
  const pathKey = Object.keys(helpContent).find(key => {
    if (key === '/') return location.pathname === '/';
    return location.pathname.startsWith(key);
  }) || '/';

  const content = helpContent[pathKey];
  if (!content) return null;

  return (
    <>
      <button
        className="help-button"
        onClick={() => setOpen(true)}
        title="Hilfe"
      >
        ?
      </button>

      {open && (
        <div className="modal-overlay" onClick={() => setOpen(false)}>
          <div className="modal help-modal" onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <h3 style={{ color: 'var(--mc-gold)' }}>&#10067; Hilfe: {content.title}</h3>
              <button
                className="btn btn-secondary btn-sm"
                onClick={() => setOpen(false)}
              >
                Schliessen
              </button>
            </div>
            <div style={{
              whiteSpace: 'pre-wrap',
              lineHeight: '1.8',
              color: 'var(--text-primary)',
              background: 'rgba(0,0,0,0.2)',
              border: '3px solid var(--mc-coal)',
              padding: 16,
            }}>
              {content.text}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default HelpButton;
